// extracted by mini-css-extract-plugin
module.exports = {"container":"_4d935d0799--container--tHagz","content":"_4d935d0799--content--Cd1rg"};